import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const ModalScreen = (props) =>
{

  const children = React.Children.map(props.children, child =>
    React.isValidElement(child)
      ? React.cloneElement(child, { onClose: props.onClose })
      : child
  );

  if (!props.show) return '';
  return (
    <div className={`modal ${props.className||''}`}>
      <div className="modal-box">
        <div className={`modal-head action-panel ${props.color||''}`}>
          <h2>{ props.title }</h2>
          <div onClick={ e=>props.onClose?.() } >
            <FontAwesomeIcon className="btn" icon={faTimes} />
          </div>
        </div>
        <div className="modal-body">
          { children }
        </div>
      </div>
    </div>
  );

}

export default ModalScreen;
